// import ReportManagement from "../../components/Report-management";
import {Url} from '../../config/config'
import axios from 'axios'
import { isLoggedIn } from '../../utils'
import { ReportManagements } from "../actionTypes";

export const transactionReportInitiate = () => ({
    type:ReportManagements.TRANSACTION_REPORT_INITIATE
  })
  
  export const transactionReportSuccess = (data) => ({
    type:ReportManagements.TRANSACTION_REPORT_SUCCESS,
    payload:data
  })
  
  export const transactionReportFailure = (data) => ({
    type:ReportManagements.TRANSACTION_REPORT_FAILURE,
    payload: data
  })
  
  export function transactionReportAction(payload) {
    return dispatch => {
        const token = isLoggedIn("ownerLogin");
       dispatch(transactionReportInitiate(payload))
        return new Promise((resolve, reject) =>
            axios.post(`${Url}store/transactionManagementReports`, payload,{
                headers: { Authorization: `${token}` }
              })
                .then(response => {
                  const data = response.data
             
                    if (data.status=== 200){
                        dispatch(transactionReportSuccess(data))
                    }
                    else  if (data.status=== 505){
                      dispatch(transactionReportFailure(data))
                  }
                    else{
                      dispatch(transactionReportFailure(data))
                    }
                    resolve(data);
                })
                .catch(err => {
                    dispatch(transactionReportFailure(err))
                    reject(err);
                })
        );
    }
  }


 export  const adminPaymentInitiate = () => ({
    type:ReportManagements.ADMIN_PAYMENT_REPORT_INITIATE
  })
  
  export const adminPaymentSuccess = (data) => ({
    type:ReportManagements.ADMIN_PAYMENT_REPORT_SUCCESS,
    payload:data
  })
  
  export const adminPaymentFailure = (data) => ({
    type:ReportManagements.ADMIN_PAYMENT_REPORT_FAILURE,
    payload: data
  })
  
  export function adminPaymentAction(payload) {
    return dispatch => {
        const token = isLoggedIn("ownerLogin");
       dispatch(adminPaymentInitiate(payload))
        return new Promise((resolve, reject) =>
            axios.post(`${Url}store/adminPaymentReport`, payload,{
                headers: { Authorization: `${token}` }
              })
                .then(response => {
                  const data = response.data
             
                    if (data.status=== 200){
                        dispatch(adminPaymentSuccess(data))
                    }
                    else  if (data.status=== 505){
                      dispatch(adminPaymentFailure(data))
                  }
                    else{
                      dispatch(adminPaymentFailure(data))
                    }
                    resolve(data);
                })
                .catch(err => {
                    dispatch(adminPaymentFailure(err))
                    reject(err);
                })
        );
    }
  }
 

  export  const orderReportInitiate = () => ({
    type:ReportManagements.ORDER_REPORT_INITIATE
  })
  
  export const orderReportSuccess = (data) => ({
    type:ReportManagements.ORDER_REPORT_SUCCESS,
    payload:data
  })
  
  export const orderReportFailure = (data) => ({
    type:ReportManagements.ORDER_REPORT_FAILURE,
    payload: data
  })
  
  export function orderReportAction(payload) {
    return dispatch => {
        const token = isLoggedIn("ownerLogin");
    
       dispatch(orderReportInitiate())
        return new Promise((resolve, reject) =>
            axios.post(`${Url}store/adminPaymentReport`, payload,{
                headers: { Authorization: `${token}` }
              })
                .then(response => {
                  const data = response.data
             
                    if (data.status=== 200){
                        dispatch(orderReportSuccess(data))
                    }
                    else  if (data.status=== 505){
                      dispatch(orderReportFailure(data))
                  }
                    else{
                      dispatch(orderReportFailure(data))
                    }
                    resolve(data);
                })
                .catch(err => {
                    dispatch(orderReportFailure(err))
                    reject(err);
                })
        );
    }
  }
 

  
  export  const productReportInitiate = () => ({
    type:ReportManagements.PRODUCT_REPORT_INITIATE
  })
  
  export const productReportSuccess = (data) => ({
    type:ReportManagements.PRODUCT_REPORT_SUCCESS,
    payload:data
  })
  
  export const productReportFailure = (data) => ({
    type:ReportManagements.PRODUCT_REPORT_FAILURE,
    payload: data
  })
  
  export function productReportAction(payload) {
    return dispatch => {
        const token = isLoggedIn("ownerLogin");
       dispatch(productReportInitiate())
        return new Promise((resolve, reject) =>
            axios.post(`${Url}store/productReport`, payload,{
                headers: { Authorization: `${token}` }
              })
                .then(response => {
                  const data = response.data
             
                    if (data.status=== 200){
                        dispatch(productReportSuccess(data))
                    }
                    else  if (data.status=== 505){
                      dispatch(orderReportFailure(data))
                  }
                    else{
                      dispatch(productReportFailure(data))
                    }
                    resolve(data);
                })
                .catch(err => {
                    dispatch(productReportFailure(err))
                    reject(err);
                })
        );
    }
  }
 